export const FILTERS_TYPES = {
  SET_SEARCH: 'filters/SET_SEARCH',
  RESET_SEARCH: 'filters/RESET_SEARCH',
};

export default function reducer(
  state = { searchTerm: null, resetSearchTerm: false },
  action
) {
  switch (action.type) {
    case FILTERS_TYPES.SET_SEARCH: {
      return { ...state, searchTerm: action.payload };
    }
    case FILTERS_TYPES.RESET_SEARCH: {
      return { ...state, searchTerm: null };
    }
    default:
      return state;
  }
}
